import { isMobile } from '../../../../core/helpers/isMobile';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { checkHashStore } from '../../../../store/checkHashStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';

export const SECTORS_DEG = {
  10: 36,
  20: 18,
  30: 12,
  40: 9,
  50: 7.3,
};

export const WHEEL_ANIMATION_SECONDS = {
  default: 2,
  turbo: 0.1,
};

export const RiskType = {
  low: 2,
  medium: 1,
  high: 0,
};

export const SelectorType = {
  _10: 0,
  _20: 1,
  _30: 2,
  _40: 3,
  _50: 4,
};

export const riskButtonConfigs = [
  {
    buttonType: RiskType.low,
    name: TranslationKeys.Low,
    color: 'green',
  },
  {
    buttonType: RiskType.medium,
    name: TranslationKeys.Medium,
    color: 'yellow',
  },
  {
    buttonType: RiskType.high,
    name: TranslationKeys.High,
    color: 'red',
  },
];

export const selectorButtonConfigs = [
  {
    buttonType: SelectorType._10,
    name: '10',
    // color: 'green',
  },
  {
    buttonType: SelectorType._20,
    name: '20',
    // color: 'green',
  },
  {
    buttonType: SelectorType._30,
    name: '30',
    // color: 'green',
  },
  {
    buttonType: SelectorType._40,
    name: '40',
    // color: 'green',
  },
  {
    buttonType: SelectorType._50,
    name: '50',
    // color: 'green',
  },
];

export const SECTORS_COLORS_INDEXES = {
  low10: {
    indexes: {
      green: [0],
      white: [1, 2, 3, 5, 6, 7, 8],
      gray: [4, 9],
    },
  },
  low20: {
    indexes: {
      green: [0, 10],
      white: [1, 2, 3, 5, 6, 7, 8, 11, 12, 13, 15, 16, 17, 18],
      gray: [4, 9, 14, 19],
    },
  },
  low30: {
    indexes: {
      green: [0, 10, 20],
      white: [1, 2, 3, 5, 6, 7, 8, 11, 12, 13, 15, 16, 17, 18, 21, 22, 23, 25, 26, 27, 28],
      gray: [4, 9, 14, 19, 24, 29],
    },
  },
  low40: {
    indexes: {
      green: [0, 10, 20, 30],
      white: [
        1, 2, 3, 5, 6, 7, 8, 11, 12, 13, 15, 16, 17, 18, 21, 22, 23, 25, 26, 27, 28, 31, 32, 33, 35,
        36, 37, 38,
      ],
      gray: [4, 9, 14, 19, 24, 29, 34, 39],
    },
  },
  low50: {
    indexes: {
      green: [0, 10, 20, 30, 40],
      white: [
        1, 2, 3, 5, 6, 7, 8, 11, 12, 13, 15, 16, 17, 18, 21, 22, 23, 25, 26, 27, 28, 31, 32, 33, 35,
        36, 37, 38, 41, 42, 43, 45, 46, 47, 48,
      ],
      gray: [4, 9, 14, 19, 24, 29, 34, 39, 44, 49],
    },
  },
  medium10: {
    indexes: {
      green: [3, 7],
      orange: [1],
      gray: [0, 2, 4, 6, 8],
      yellow: [5],
      purple: [9],
    },
  },
  medium20: {
    indexes: {
      green: [0, 8],
      orange: [12],
      gray: [1, 3, 5, 7, 9, 11, 13, 15, 17, 19],
      yellow: [2, 4, 6, 14, 16, 18],
      purple: [10],
    },
  },
  medium30: {
    indexes: {
      green: [0, 2, 6, 12, 16, 26],
      orange: [22],
      gray: [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29],
      yellow: [4, 8, 10, 18, 20, 28],
      purple: [14],
      magenta: [24],
    },
  },
  medium40: {
    indexes: {
      green: [6, 10, 12, 16, 20, 30, 34, 38],
      orange: [26],
      gray: [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35, 37, 39],
      yellow: [0, 4, 14, 22, 24, 28, 36],
      purple: [2, 8, 18, 32],
    },
  },
  medium50: {
    indexes: {
      green: [2, 6, 10, 12, 16, 20, 24, 30, 34, 38, 40, 44, 48],
      gray: [
        1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35, 37, 39, 41, 43, 45, 47,
        49,
      ],
      yellow: [0, 4, 14, 22, 26, 28, 36, 46],
      purple: [8, 18, 32],
      blue: [42],
    },
  },
  high10: {
    indexes: {
      orange: [9],
      gray: [0, 1, 2, 3, 4, 5, 6, 7, 8],
    },
  },
  high20: {
    indexes: {
      orange: [19],
      gray: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
    },
  },
  high30: {
    indexes: {
      orange: [29],
      gray: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
        25, 26, 27, 28,
      ],
    },
  },
  high40: {
    indexes: {
      orange: [39],
      gray: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
        25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,
      ],
    },
  },
  high50: {
    indexes: {
      orange: [49],
      gray: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
        25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 45, 44, 46, 47,
        48,
      ],
    },
  },
};

export const SECTOR_COLORS_TYPES = {
  0: 'gray',
  1: 'white',
  2: 'green',
  3: 'yellow',
  4: 'purple',
  5: 'orange',
  6: 'blue',
  7: 'magenta',
};

export const RISK_TYPES = [
  {
    type: 2,
    typeName: 'LOW',
    color: 'green',
  },
  {
    type: 1,
    typeName: 'MEDIUM',
    color: 'yellow',
  },
  {
    type: 0,
    typeName: 'HIGH',
    color: 'red',
  },
];

export const SECTORS_TYPES = [0, 1, 2, 3, 4];

export const RISK_TYPES_FOR_CLASS = {
  2: 'low',
  1: 'medium',
  0: 'high',
};

export const SECTORS_TYPES_FOR_CLASS = {
  0: '10',
  1: '20',
  2: '30',
  3: '40',
  4: '50',
};

export const WHEEL_GAME_ID = 42;

export const WheelLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Sectors,
    dataKey: 'sectors',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <span className='cpt-table-text'>
        {SECTORS_TYPES_FOR_CLASS[spinInfo.spinData.sectorCountType]}
      </span>
    ),
  },
  {
    title: TranslationKeys.Risk,
    dataKey: 'risk',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo, t) => (
      <span className='cpt-table-text'>
        {t(RISK_TYPES_FOR_CLASS[spinInfo.spinData.riskType].toUpperCase())}
      </span>
    ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const WheelBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'id',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({ name: PopupTypes.Fairness, spinInfo });
          checkHashStore.setSpinInfo({
            salt: spinInfo.salt,
            key: spinInfo.key,
            hash: spinInfo.hash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Sectors,
    dataKey: 'default',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <span className='cpt-table-text'>{SECTORS_TYPES_FOR_CLASS[spinInfo.sectorCount]}</span>
    ),
  },
  {
    title: TranslationKeys.Risk,
    dataKey: 'default1',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo, t) => (
      <span className='cpt-table-text'>
        {t(RISK_TYPES_FOR_CLASS[spinInfo.riskType].toUpperCase())}
      </span>
    ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const WheelSoundsName = {
  win: 'win',
  bet: 'bet',
  lose: 'lose',
  spinning: 'spinning',
};

export const WheelSoundsPath = [
  {
    src: 'audio/wheel/bet.mp3',
    name: WheelSoundsName.bet,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/wheel/win.mp3',
    name: WheelSoundsName.win,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/wheel/lose.mp3',
    name: WheelSoundsName.lose,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/wheel/spinning.mp3',
    name: WheelSoundsName.spinning,
    autoplay: false,
    html5: true,
  },
];

export const WHEEL_RULES_KEYS = new Array(8).fill(null).map((item, index) => index + 1);
export const WHEEL_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
